function getIsCypressOnLocalhost() {
  return (
    window.location.hostname === 'localhost' &&
    (window.Cypress || window.parent?.Cypress)
  );
}
export default getIsCypressOnLocalhost;
